import CreateChallengeLegacy from './challenges/CreateChallengeLegacy.jsx';

export default function CreateChallengePage() {
  return (
    <div className="legacy-challenge-editor -m-2 max-w-[1100px] rounded-xl border border-slate-200/80 bg-white p-4 shadow-soft">
      <CreateChallengeLegacy />
    </div>
  );
}
